// 1000ms * 60 seconds * 30 minutes = 30 mins in milliseconds
export const timeout = 1000 * 60 * 30
export const promptBeforeIdle = 1000 * 60
